<template>
  <svg width="30px" height="30px"
       viewBox="0 0 30 30" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/30x30/add/black</title>
    <g id="atoms/icons/30x30/add/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M15,2.5 C15.5522847,2.5 16,2.94771525 16,3.5 L16,14 L26.5,14 C27.0522847,14 27.5,14.4477153 27.5,15 C27.5,15.5522847 27.0522847,16 26.5,16 L16,16 L16,26.5 C16,27.0522847 15.5522847,27.5 15,27.5 C14.4477153,27.5 14,27.0522847 14,26.5 L14,16 L3.5,16 C2.94771525,16 2.5,15.5522847 2.5,15 C2.5,14.4477153 2.94771525,14 3.5,14 L14,14 L14,3.5 C14,2.94771525 14.4477153,2.5 15,2.5 Z" id="Combined-Shape"
            fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
